
import Vue from "vue";
export default Vue.extend({
  props: {
    flat: {
      required: false,
      type: Boolean,
      default: true,
    },
  },
});
